import { useEffect, useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { MST4030_R01DetailDto, MST4030_R01HeaderDto } from "./Dto_MST4030_R01";
import { useMST4030_R01Store } from "./Store_MST4030_R01";
import { AgGridReact } from "ag-grid-react";
import { Table_MST4030_R01 } from "./Table_MST4030_R01";
import { Info_MST4030_R01 } from "./Info_MST4030_R01";
import { DetailTable_MST4030_R01 } from "./DetailTable_MST4030_R01";
import { SearchSection_MST4030_R01 } from "./SearchSection_MST4030_R01";
import { Content_MST4030_R01 } from "./Content_MST4030_R01";
import { LabelBulkPrintModal_MST4030_R01 } from "./LabelPrintModal_MST4030_R01";

export const Container_MST4030_R01 = () => {

	const {
		MST4030_R01List,
		MST4030_R01DetailList,
		selectedMST4030_R01,
	} = useMST4030_R01Store();

	const { setMessage } = useUiuxStore();

	const [isLabelModalOpen, setIsLabelModalOpen] = useState(false);

	const RESIZER = {
		code: 'MST4030_R01',
		type: 'width',
		storageKey: 'MST4030_R01-split-width',
		min: 5,
		max: 80,
		default: 35
	} as const;

	const gridRef = useRef<AgGridReact<MST4030_R01HeaderDto> | null>(null);
	const detailGridRef = useRef<AgGridReact<MST4030_R01DetailDto> | null>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { splitValue, handleMouseDown } = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const INFO_RESIZER = {
		code: 'MST4030_R01_info',
		type: 'height',
		storageKey: 'MST4030_R01-info-split-height',
		min: 5,
		max: 80,
		default: 40
	} as const;

	const infoContainerRef = useRef<HTMLDivElement>(null);
	const detailContainerRef = useRef<HTMLDivElement>(null);
	const isInfoResizing = useRef(false);

	const { splitValue: infoSplitValue, handleMouseDown: handleInfoMouseDown } = useMouseContent({
		resizer: INFO_RESIZER,
		isResizing: isInfoResizing,
		containerRef: infoContainerRef,
		infoRef: detailContainerRef
	});

	const {
		handleExcelClick,
		handlePrintClick,
		fetchData,
		defaultMST4030_R01HeaderRow,
		defaultMST4030_R01DetailRow,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_MST4030_R01({
		gridRef,
		detailGridRef,
		setMessage,
		containerRef,
		isResizing,
	});

	useEffect(() => {
		if (MST4030_R01List.length === 0 && MST4030_R01DetailList.length === 0) {
			handleCreateClick();
		}
	}, [MST4030_R01List, MST4030_R01DetailList, handleCreateClick]);

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleCreateClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_MST4030_R01
				onBulkLabelClick={() => setIsLabelModalOpen(true)}
			/>
			<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_MST4030_R01 gridRef={gridRef} />
				</div>
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				/>
				<div className="h-full flex flex-col" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
					<div className="w-full h-full flex flex-col gap-[4px]" ref={infoContainerRef}>
						<div className="w-full" style={{ height: `${infoSplitValue}%` }} ref={detailContainerRef}>
							<Info_MST4030_R01
								data={selectedMST4030_R01}
								defaultMST4030_R01HeaderRow={defaultMST4030_R01HeaderRow()}
							/>
						</div>
						<div
							className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
							onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleInfoMouseDown("UD", e.nativeEvent)}
							onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
						/>
						<div className="w-full" style={{ height: `${100 - infoSplitValue}%` }}>
							<DetailTable_MST4030_R01
								gridRef={detailGridRef}
								defaultMST4030_R01DetailRow={defaultMST4030_R01DetailRow()}
							/>
						</div>
					</div>
				</div>
			</div>
			<Message />

			<LabelBulkPrintModal_MST4030_R01
				isOpen={isLabelModalOpen}
				onClose={() => setIsLabelModalOpen(false)}
				dataList={MST4030_R01List}
				defaultMST4030_R01HeaderRow={defaultMST4030_R01HeaderRow()}
			/>
		</div>
	);
};
